/* Shipping Protection opt-in (t-1f614a, funnels-flows).
 * PDP: an UNTICKED checkbox above the buy button. When ticked, the SP variant
 * rides inside the same /cart/add request the theme or app already sends
 * (Kaching Bundles, PagePilot, Horizon product-form), so the existing
 * buy-now redirect, selling plan and bundle discounts stay untouched.
 * Drawer: the checkbox mirrors the cart; ticking adds SP, unticking removes it.
 * The SP variant id comes from one theme setting (settings.sp_variant_id).
 */
(function () {
  if (window.__spOptinInit) return;
  window.__spOptinInit = true;

  var origFetch = window.fetch.bind(window);
  var variant = null; // resolved /variants/<id>.js payload, only when available
  var variantId = 0;

  function roots() {
    return document.querySelectorAll('[data-sp-root]');
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: currency,
      }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function hydrate() {
    if (!variant) return;
    var price = '(' + formatMoney(variant.price) + ')';
    roots().forEach(function (root) {
      if (root.dataset.spReady === '1') return;
      root.querySelectorAll('[data-sp-price]').forEach(function (el) {
        el.textContent = price;
      });
      root.hidden = false;
      root.dataset.spReady = '1';
    });
  }

  function pdpChecked() {
    var input = document.querySelector('[data-sp-root][data-sp-context="pdp"] [data-sp-input]');
    return input ? input.checked : null; // null = no PDP opt-in on this page
  }

  function cartPath(path) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + path;
  }

  function getCart() {
    return origFetch(cartPath('/cart.js'), { credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function spLine(cart) {
    return (cart.items || []).find(function (i) {
      return i.variant_id === variantId;
    });
  }

  function removeLine(key) {
    return origFetch(cartPath('/cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }

  function addSp() {
    return origFetch(cartPath('/cart/add.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    });
  }

  function isCartAdd(input, init) {
    var url = typeof input === 'string' ? input : input instanceof URL ? input.href : (input && input.url) || '';
    var method = ((init && init.method) || (input && typeof input === 'object' && input.method) || 'GET').toUpperCase();
    if (method !== 'POST') return false;
    try {
      return /\/cart\/add(\.js)?$/.test(new URL(url, location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  /* Returns a new init whose JSON body carries the SP line, or null when the
     body is not JSON (FormData etc.); those get a follow-up add instead. */
  function withSpInBody(init) {
    if (!init || typeof init.body !== 'string') return null;
    var body;
    try {
      body = JSON.parse(init.body);
    } catch (e) {
      return null;
    }
    if (!body || typeof body !== 'object') return null;
    if (!Array.isArray(body.items)) {
      if (!body.id) return null;
      var line = { id: body.id, quantity: body.quantity || 1 };
      if (body.properties) line.properties = body.properties;
      if (body.selling_plan) line.selling_plan = body.selling_plan;
      delete body.id;
      delete body.quantity;
      delete body.properties;
      delete body.selling_plan;
      body.items = [line];
    }
    var already = body.items.some(function (i) {
      return Number(i.id) === variantId;
    });
    if (!already) body.items.push({ id: variantId, quantity: 1 });
    return Object.assign({}, init, { body: JSON.stringify(body) });
  }

  window.fetch = function (input, init) {
    var want = variant ? pdpChecked() : null;
    if (want === null || !isCartAdd(input, init)) return origFetch(input, init);

    // Everything before the real request may fail open: the shopper's own add
    // must never be blocked by the SP layer.
    var prep = getCart()
      .then(function (cart) {
        var line = spLine(cart);
        if (!want) return line ? removeLine(line.key).then(function () { return { init: init, followUp: false }; }) : { init: init, followUp: false };
        if (line) return { init: init, followUp: false }; // already in cart, keep qty 1
        var augmented = withSpInBody(init);
        return augmented ? { init: augmented, followUp: false } : { init: init, followUp: true };
      })
      .catch(function () {
        return { init: init, followUp: false };
      });

    return prep.then(function (plan) {
      return origFetch(input, plan.init).then(function (response) {
        if (!plan.followUp || !response.ok) return response;
        return addSp()
          .catch(function () {})
          .then(function () {
            return response;
          });
      });
    });
  };

  /* Drawer checkbox: mirrors the cart. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-sp-root][data-sp-context="drawer"] [data-sp-input]')) return;
    if (!variant) return;
    input.disabled = true;
    var op = input.checked
      ? addSp()
      : getCart().then(function (cart) {
          var line = spLine(cart);
          return line ? removeLine(line.key) : null;
        });
    Promise.resolve(op)
      .then(getCart)
      .then(function (cart) {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'sp-optin', data: { itemCount: cart.item_count, source: 'sp-optin' } },
          })
        );
      })
      .catch(function (e) {
        console.warn('[sp-optin]', e);
      })
      .finally(function () {
        input.disabled = false;
      });
  });

  function init() {
    var first = document.querySelector('[data-sp-root]');
    variantId = first ? Number(first.dataset.spVariant) : 0;
    if (!variantId) return;
    origFetch(cartPath('/variants/' + variantId + '.js'), { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (v) {
        if (!v || !v.available) return; // fail closed: never show an option that cannot be carted
        variant = v;
        hydrate();
        // The drawer re-renders by morphing; re-hydrate new roots.
        new MutationObserver(function () {
          var pending = document.querySelector('[data-sp-root]:not([data-sp-ready="1"])');
          if (pending) hydrate();
        }).observe(document.body, { childList: true, subtree: true });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
